<div class="container-btn" (click)="openModal()">
    <div>
        <p class="title">¿Necesitas ayuda con este trámite?</p>
    </div>
    <div class="container-img">
        <ion-img src="./../../../assets/icon/vitalia-cellphone.svg"></ion-img>
    </div>
</div>